export default __webpack_public_path__ + "static/media/filterIcon.959c7a72.svg";